import void_ava from 'assets/gap_avatar.svg';
import CommonHelper from "helpers/CommonHelper";
import styled from "styled-components";

import Avatar from "./components/Avatar";
import MessageParts from "./components/MessageParts";

const getAvatarUrl = (message) => {
  if (message?.avatar === 'gap') {
    return void_ava;
  }
  return message?.avatar || message?.content?.avatar || void_ava;
};

const capitalize = (str) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
};

const CharacterMessage = (props) => {
  const {
    message,
    topRightComponent,
    onZoomClick,
    isShowVideoAvatar,
    videoAvatarUrl,
  } = props;
  const { content = {}, name } = message;
  const { parts = [], type } = content;

  return (
    <div className="character_message_placeholder mb-2">
      <div className="flex flex-row items-start">
        <Avatar
          videoAvatarUrl={videoAvatarUrl}
          imageUrl={CommonHelper.getFilesCdnUrl(getAvatarUrl(message))}
          onZoomClick={onZoomClick}
          isShowVideoAvatar={isShowVideoAvatar}
        />
        <RightPlaceholder className="right_placeholder box_placeholder rounded p-2 pr-0">
          <NamePlaceholder className="mb-2 text-white">{capitalize(name)}</NamePlaceholder>
          {parts.length > 0 && (<MessageBubble className={topRightComponent ? 'flex flex-row items-center' : ''}>
            {type === 'text' && <PartsPlaceholder><MessageParts parts={parts} /></PartsPlaceholder>}
            {topRightComponent && <div>{topRightComponent}</div>}
          </MessageBubble>)}
        </RightPlaceholder>
      </div>
    </div>
  );
};

export default CharacterMessage;

const RightPlaceholder = styled.div`
  color: #ff7e55;
`;

const NamePlaceholder = styled.div`
  color: #fff;
  font-family: Nunito Sans;
  font-size: 16px;
  line-height: 18px;
  font-weight: bold;
`;

const MessageBubble = styled.div`
  background: rgba(19, 19, 19, 1);
  border-radius: 12px;
  border-top-left-radius: 4px !important;
  padding: 20px;
  font-size: 16px;
  font-weight: 400;
  font-family: Nunito Sans;
`;

const PartsPlaceholder = styled.div`
  max-width: 520px;
  color: white;
  font-family: 'Nunito Sans';
  font-size: 16px;
`;
